export default __webpack_public_path__ + "static/plan-anytime-195af8acee1d4f4b3cf78d98f9c90354.svg";